export default {"src":"/_next/static/media/search.40774b42.svg","height":16,"width":16};